import styled from 'styled-components';
import { designTokens } from '../foundation/DesignTokens';

// Base badge component
export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: ${designTokens.radius.full};
  font-size: 0.75rem;
  font-weight: 700;
  font-family: ${designTokens.fonts.body};
  white-space: nowrap;
  background: ${(props) => props.bg || designTokens.colors.gray[100]};
  color: ${(props) => props.color || designTokens.colors.gray[500]};

  @media (max-width: 900px) {
    font-size: 0.7rem;
    padding: 3px 8px;
  }
`;

// Predefined badge variants
export const BadgeBlue = styled(Badge)`
  background: #DBEAFE;
  color: #1E40AF;
`;

export const BadgeGreen = styled(Badge)`
  background: #DCFCE7;
  color: #166534;
`;

export const BadgeYellow = styled(Badge)`
  background: #FEF3C7;
  color: #92400E;
`;

export const BadgeRed = styled(Badge)`
  background: #FEE2E2;
  color: #B91C1C;
`;

export const BadgePurple = styled(Badge)`
  background: #F5F3FF;
  color: #4C1D95;
`;

export const BadgeGray = styled(Badge)`
  background: ${designTokens.colors.gray[100]};
  color: ${designTokens.colors.gray[500]};
`;

export const BadgeOrange = styled(Badge)`
  background: #FFEDD5;
  color: #9A3412;
`;

export const BadgeTeal = styled(Badge)`
  background: #ECFEFF;
  color: #0E7490;
`;

export const BadgePink = styled(Badge)`
  background: #FCE7F3;
  color: #9F1239;
`;

export const BadgeIndigo = styled(Badge)`
  background: #EEF2FF;
  color: #4338CA;
`;

// Badge variants by status
export const BadgeSuccess = BadgeGreen;
export const BadgeWarning = BadgeYellow;
export const BadgeError = BadgeRed;
export const BadgeInfo = BadgeBlue;

// Helper function to get badge by variant name
export const getBadgeVariant = (variant) => {
  const variants = {
    blue: BadgeBlue,
    green: BadgeGreen,
    yellow: BadgeYellow,
    red: BadgeRed,
    purple: BadgePurple,
    gray: BadgeGray,
    orange: BadgeOrange,
    teal: BadgeTeal,
    pink: BadgePink,
    indigo: BadgeIndigo,
    success: BadgeSuccess,
    warning: BadgeWarning,
    error: BadgeError,
    info: BadgeInfo,
  };

  return variants[variant] || Badge;
};

export default Badge;
